import React, { useState, useContext } from "react";
import "../style/rechargeSupme.css";
import { UserContext } from "../App";
import TransactionRecHistory from "./TransactionRe_his";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";

export default function RechargeSupme() {
  const { user } = useContext(UserContext);

  const formatSurplus = (value) => {
    if (value === null || value === undefined) {
      return "";
    }
    const num = Number(value);
    if (isNaN(num)) {
      return value;
    }
    return num.toLocaleString("vi-VN");
  };

  return (
    <div className="tab-container container-fluid">
      <div className="row mb-2 gx-2">
        <div className="col-6 text-center">
          <b className="small">Ví tài khoản:</b>
          <b className="text-theme mb-0">
            <span id="moneyMobile">
              {" "}
              {formatSurplus(user?.data[0]?.surplus)}
            </span>
          </b>
        </div>
      </div>

      <div className="container">
        <div className="card border-0 mb-4 shadow-md">
            <div className="card-body bg-none py-3">
              <div className="card-body">
                <div className="info-section">
                  <p className="small text-warning animated-text">
                    <i className="fas fa-exclamation-circle"></i>
                    <strong> Đây là hệ thống chỉ hỗ trợ mọi người nạp xu một cách nhanh chóng và tiện lợi, một số app được cung cấp sẵn ở hệ thống. Mọi khoản tiền ở website chỉ được nạp xu, và không thể thực hiện bất kỳ thao tác nào, rút, hoặc trao đổi ngược lại thành tiền.
Mọi Người Vui Lòng Chú Ý.</strong>
                  </p>

                  <p className="small animated-text">
                    - Vui lòng liên hệ qua Zalo Hanna:
                    <span className="text-theme"> <b>033.327.1551</b> </span>
                    (không gọi điện) để được hướng dẫn xác thực và cộng tiền thủ công.
                  </p>
                </div>
              </div>
            </div>
        </div>
        <TransactionRecHistory userName={user?.data[0]?.UserName} />
        <NotificationContainer />
      </div>
      <div className="container-fluid">
        
      </div>
    </div>
  );
}
